export const sanitizeFileName = (filename: string) => {
    const start = 0;
    const MAX_SPLITTED_LENGTH = 30;
    const end = filename.lastIndexOf('.');
    const splittedLength = end > MAX_SPLITTED_LENGTH ? MAX_SPLITTED_LENGTH : end;
    const fileExtension = filename.slice(end);
    console.log('fileExtension : ', fileExtension);

    return filename.replace(/[^a-zA-Z0-9.,]/g, '0').slice(start, splittedLength) + fileExtension;
  };
  